exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".associate-tree label{margin-bottom:0!important}", ""]);

// exports
